import { useCallback, useEffect } from 'react';

import type { LeaseActionProps } from '../../../models/Types';
import { logError } from '@zg-rentals/log-error';
import { Toast, useToast } from '@zillow/constellation-10';
import { useResendSigningEmailsMutation } from '../../../utils/queries';
import { LeaseArtifactType } from '@zg-rentals/ts-leasing-client';

type Props = LeaseActionProps;

function ResendSigningEmails({ lease }: Props) {
  const { enqueueToast } = useToast();
  const resendSigningEmailsMutation = useResendSigningEmailsMutation();

  const onEmailSentSuccess = useCallback(() => {
    enqueueToast(<Toast tone="success">Emails for signing successfully resent</Toast>);
  }, [enqueueToast]);

  const onEmailSendError = useCallback(() => {
    enqueueToast(<Toast tone="critical">Emails for signing were not resent, try again later</Toast>);
  }, [enqueueToast]);

  useEffect(() => {
    resendSigningEmailsMutation
      .mutateAsync({
        postData: {
          leaseArtifactId: lease.id as unknown as number,
          leaseArtifactType: LeaseArtifactType.LEASE,
        },
      })
      .then(function () {
        onEmailSentSuccess();
        return;
      })
      .catch(function (error) {
        logError({ error, context: 'ResendSigningEmails' });
        onEmailSendError();
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}

export default ResendSigningEmails;
